import { Divider, styled } from "@mui/material";

/**
 * Divider with important margins because of a base style from MUI
 * https://github.com/mui/material-ui/issues/29703
 */
export const StyledDivider = styled(Divider)(() => ({
  marginTop: "1.5rem !important",
}));
